module.exports = __webpack_public_path__ + "static/img/home1.fa9e6d1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/home1.jpg
// module id = z6eN
// module chunks = 128